import { Pipe, PipeTransform } from '@angular/core';
import { HospitalLanguageService } from './hospital-language.service';

/**
 * 単一の「表示文字」ではない。`transform(入力)` のたびに `language.txt` 由来の Map を参照する。
 * 例: `{{ '患者' | hospLang }}` はキー「患者」→「利用者」、`{{ '看護師' | hospLang }}` はキー「看護師」→「スタッフ」。
 * 入力文字列ごとに別エントリ（病院側キー → 施設側）が適用される。
 */
@Pipe({
  name: 'hospLang',
  standalone: true,
  pure: false,
})
export class HospitalLangPipe implements PipeTransform {
  constructor(private hospitalLanguage: HospitalLanguageService) {}

  transform(value: string | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    return this.hospitalLanguage.t(value);
  }
}
